/**
 * @file 云钱包场景下的质押
 */
import { useCurrentToken } from '@/containers/operation/stake/hooks';
import { useSlippage } from '@/containers/operation/hooks';
import { Button } from '@bfe/moly';
import {
  InputArea,
  StakeProcess,
} from '@/containers/operation/stake/components';
import { useGasFee, useStake, useButtonStatus } from './hooks';
import { Process } from '@/types/stake';
import styles from './index.module.less';
import ErrorIcon from '@/assets/images/bybitsol/error.svg';
import { EarnArea } from '@/containers/operation/stake/components/earnArea';
import cls from 'classnames';
export const CloudStake = ({ activity }) => {
  const { slippage } = useSlippage();

  const {
    stakeAmount,
    currentStakeToken,
    aprPerDay,
    aprPreDayAmount,
    process,
    onChangeProcess,
    onChangeStakeAmount,
    onChangeCurrentToken,
  } = useCurrentToken();

  // 预估接口提到gas fee前面，后续接其他链时需要放开限制
  const { gasStore, stakeLpInfo } = useGasFee({
    stakeAmount,
    aprPerDay,
    currentStakeToken,
    process,
  });

  const {
    stakeEmergencyDisable,
    stakeIsHidden,
    buttonDisabled,
    buttonText,
    textError,
    onClickStake,
    onChangeTextError,
  } = useButtonStatus({
    stakeAmount,
    currentStakeToken,
    gasStore,
    onChangeProcess,
  });

  const { confirmButtonIsLoading, beginStake, orderCode } = useStake({
    stakeAmount,
    stakeLpInfo,
    currentStakeToken,
    slippage,
    gasStore,
    onChangeProcess,
  });

  const enableStakeBtn = !stakeIsHidden && !stakeEmergencyDisable;
  return (
    <div className={styles.container}>
      {/* 输入区 */}
      <InputArea
        stakeAmount={stakeAmount}
        gasStore={gasStore}
        currentStakeToken={currentStakeToken}
        onChangeTextError={onChangeTextError}
        onChangeAmount={onChangeStakeAmount}
        onChangeCurrentToken={onChangeCurrentToken}
      />
      <EarnArea
        currentStakeToken={currentStakeToken}
        aprPreDayAmount={aprPreDayAmount}
        stakeAmount={stakeAmount}
        stakeLpInfo={stakeLpInfo}
        activity={activity}
      />
      {/* 质押按钮 */}
      <div className={styles.btnContainer}>
        <div className={cls(styles.error, textError ? styles.errorShow : '')}>
          <ErrorIcon className={styles.errorIcon} />
          {textError}
        </div>
        <Button
          disabled={buttonDisabled || !enableStakeBtn}
          loading={gasStore.isLoading && !gasStore.hasGasFee}
          variant="primary"
          size="large"
          className={styles.button}
          onClick={onClickStake}
        >
          {buttonText}
        </Button>
      </div>

      {/* 用户点击质押按钮后的流程控制 */}
      {process !== Process.None && (
        <StakeProcess
          stakeLpInfo={stakeLpInfo}
          aprPerDay={aprPerDay}
          process={process}
          slippage={slippage}
          stakeAmount={stakeAmount}
          currentStakeToken={currentStakeToken}
          gasStore={gasStore}
          orderCode={orderCode}
          beginStake={beginStake}
          confirmButtonText={buttonText}
          onChangeProcess={onChangeProcess}
          confirmButtonIsLoading={confirmButtonIsLoading}
        />
      )}
    </div>
  );
};
